import template from './diversificationOpportunities.template.html';
import templateTicketRefer from '../ticket/ticketRefer.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    diversificationOpportunities: '<',
    diversificationOpportunitiesComments: '<',
    contacts: '<',
    ticketClientTypes: '<',
    addresses: '<',
    documents: '<',
    outboundReferrers: '<',
    loan: '<',
    owner: '<',
    ticketValue: '<',
    ticket: '<',
    idWorkflow: '<',
    idContact: '<',
    idAli: '<',
    isTicket: '<',
    onFinished: '&',
    onCommentsFinished: '&'
  },
  controller: class controller {
    constructor(
      $state,
      $rootScope,
      $timeout,
      $mdMedia,
      $mdDialog,
      helperService,
      ticketService,
      ticketsService,
      Account,
      MessageType,
      messagesService,
      uiService,
      mergeFieldsService,
      eventService,
      smsService,
      OpportunityType,
      OpportunitySelectionType,
      OpportunityContextualType,
      diversificationOpportunityService,
      accessService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = '';
      ctrl.activeDiversificationOpportunities = [];
      ctrl.inactiveDiversificationOpportunities = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.opportunitySelectionTypes = OpportunitySelectionType.available();
        ctrl.diversificationOpportunities = ctrl.diversificationOpportunities || [];
        ctrl.diversificationOpportunitiesComments =
          ctrl.diversificationOpportunitiesComments || '';
        ctrl.contacts = ctrl.contacts || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.loan = ctrl.loan || [];
        ctrl.owner = ctrl.owner || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.ticketValue = ctrl.ticket?.values?.onceOff || 0;
        ctrl.idTicket = ctrl.ticket?.id || '';
        ctrl.idOwner = ctrl.idOwner || ctrl.owner?.id || '';
        ctrl.idWorkflow = ctrl.idWorkflow || '';
        ctrl.idContact = ctrl.idContact || '';
        ctrl.idAli = ctrl.idAli || '';
        ctrl.isTicket = ctrl.isTicket || false;
        ctrl.setDiversificationOpportunities();
        ctrl.isReady = true;
      };

      ctrl.hasReferralSetUp = ({ opportunity }) =>
        diversificationOpportunityService.showDiversificationOpportunity({
          opportunity: ctrl.isTicket
            ? OpportunityContextualType.of(opportunity?.typeContextual)
            : OpportunityType.of(opportunity?.type),
          owner: ctrl.owner,
          isTicket: ctrl.isTicket
        });

      ctrl.setDiversificationOpportunities = () => {
        const activeDiversificationOpportunities = _.filter(
          ctrl.diversificationOpportunities,
          (d) => ctrl.hasReferralSetUp({ opportunity: d })
        );
        if (ctrl.isTicket) {
          const len = activeDiversificationOpportunities.length;
          for (let i = 0; i < len; i += 1) {
            const opportunity = activeDiversificationOpportunities[i];
            let idx = _.findLastIndex(
              ctrl.activeDiversificationOpportunities,
              (d) => d?.selection?.name === OpportunitySelectionType?.accepted?.name
            );
            if (idx === -1) {
              idx = 0;
            }
            if (opportunity?.selection?.name === OpportunitySelectionType?.accepted?.name) {
              ctrl.activeDiversificationOpportunities.splice(idx, 0, opportunity);
            } else if (
              opportunity?.selection?.name === OpportunitySelectionType?.declined?.name
            ) {
              ctrl.activeDiversificationOpportunities.splice(idx + 1, 0, opportunity);
            } else {
              ctrl.activeDiversificationOpportunities.push(opportunity);
            }
          }
        } else {
          ctrl.activeDiversificationOpportunities = activeDiversificationOpportunities;
        }
        ctrl.inactiveDiversificationOpportunities = _.filter(
          ctrl.diversificationOpportunities,
          (d) => !ctrl.hasReferralSetUp({ opportunity: d })
        );
      };

      ctrl.availableReferrals = ({ opportunity }) => {
        const referrals = _.filter(
          _.find(
            ctrl.currentOrganization?.features?.configDiversification,
            (d) => d?.type?.name === opportunity?.type?.name
          )?.configuration,
          (c) => c?.name && c?.referral && c?.template
        );
        const accessReferrals = _.filter(
          ctrl.outboundReferrers,
          (o) => o?.diversification?.type === opportunity?.type?.name
        );
        const output = referrals.concat(accessReferrals);
        return output;
      };

      ctrl.getOpportunityTitle = ({ opportunity }) =>
        ctrl.isTicket ? opportunity.typeContextual.title : opportunity.type.title;

      ctrl.isReferralSetOnOpportunityGroup = ({ opportunity }) =>
        diversificationOpportunityService.isReferralSetOnOpportunityGroup({
          typeName: ctrl.isTicket ? opportunity?.typeContextual?.type : opportunity?.type?.name
        });

      ctrl.isDeclined = ({ opportunity }) =>
        ctrl.isTicket
          ? opportunity?.selection?.name === OpportunitySelectionType?.declined?.name
          : false;

      ctrl.referTicket = (a) => {
        function ticketReferController(access, ticket) {
          this.access = access;
          this.ticket = ticket;
          this.confirm = () => {
            $mdDialog.hide(true);
          };
          this.cancel = () => {
            $mdDialog.cancel(false);
          };
        }

        $mdDialog
          .show({
            locals: {
              access: a,
              ticket: ctrl.ticket
            },
            template: templateTicketRefer,
            controllerAs: '$ctrl',
            controller: ticketReferController
          })
          .then((result) => {
            if (result === true) {
              accessService.refer({
                idAccess: a.id,
                idTicket: ctrl.ticket.id
              });
            }
          });
      };

      ctrl.openReferral = ({ configuration }) => {
        if (configuration?.idWorkflow) {
          ctrl.referTicket(configuration);
        } else {
          diversificationOpportunityService
            .sendReferralEmail({
              configuration,
              documents: ctrl.documents,
              idTicket: ctrl.idTicket,
              idOwner: ctrl.idOwner,
              idWorkflow: ctrl.idWorkflow,
              idContact: ctrl.idContact,
              isTicket: ctrl.isTicket
            })
            .then((result) => {
              if (result.status && !ctrl.isTicket) {
                ctrl.onFinished({ integration: 'REFERRAL', result });
              }
            });
        }
      };

      ctrl.showReferralButton = ({ opportunity }) =>
        diversificationOpportunityService.showReferralButton({
          opportunity: ctrl.isTicket
            ? opportunity?.typeContextual?.type
            : opportunity?.type.name,
          owner: ctrl.owner
        });

      ctrl.changeDiversificationOpportunitiesComments = () => {
        ctrl.onCommentsFinished({
          diversificationOpportunitiesComments: ctrl.diversificationOpportunitiesComments
        });
      };

      ctrl.integrationFinished = (integration, result) => {
        ctrl.onFinished({ integration, result });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
